import { IconMinus, IconPlus } from "@tabler/icons-react";
import { PropsWithChildren, ReactNode, useState } from "react";

interface AccordionProps {
  title: string;
  icon?: ReactNode;
}

const Accordion = ({
  title, icon, children,
}: PropsWithChildren<AccordionProps>) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-[500px]">
      <div className="flex w-full items-center justify-between py-1">
        <div className="flex items-center gap-2">
          {icon && <div className="text-icon-bg-base">{icon}</div>}
          <span className="typography-medium-strong text-text-base">{title}</span>
        </div>
        <div className="text-icon-bg-subtle cursor-pointer">
          {isOpen
            ? <IconMinus onClick={() => setIsOpen(false)} />
            : <IconPlus onClick={() => setIsOpen(true)} />}
        </div>
      </div>
      <div className={`py-3 typography-medium-base text-text-subtle ${isOpen ? "block" : "hidden"}`}>{children}</div>
      <div className="pt-3 pb-4">
        <div className="h-px w-full bg-border-base rounded-xs" />
      </div>
    </div>
  );
};

export default Accordion;
